var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNetlifyicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126_61)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.48574 17.6332H6.25915L5.12805 16.5021V16.2755L6.85718 14.5463H8.05511L8.21486 14.7061V15.904L6.48574 17.6332ZM5.12805 4.84012V4.61353L6.25915 3.48244H6.48574L8.21486 5.21156V6.4095L8.05511 6.56925H6.85718L5.12805 4.84012Z",
    fill: "#05BDBA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0849 13.9873H13.4394L13.302 13.8499V9.99778C13.302 9.31247 13.0327 8.78128 12.2062 8.76272C11.7808 8.75156 11.2943 8.76272 10.7742 8.78316L10.6961 8.86303V13.848L10.5587 13.9854H8.91319L8.77576 13.848V7.26769L8.91319 7.13016H12.6166C14.056 7.13016 15.2224 8.2965 15.2224 9.73594V13.8499L15.0849 13.9873Z",
    fill: "#014847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.71972 11.5208H0.137437L0 11.3834V9.73406L0.137437 9.59662H6.71972L6.85716 9.73406V11.3834L6.71972 11.5208ZM23.8626 11.5208H17.2803L17.1428 11.3834V9.73406L17.2803 9.59662H23.8626L24 9.73406V11.3834L23.8626 11.5208ZM11.0509 5.07413V0.137437L11.1883 0H12.8377L12.9751 0.137437V5.07413L12.8377 5.21156H11.1883L11.0509 5.07413ZM11.0509 20.98V16.0433L11.1883 15.9059H12.8377L12.9751 16.0433V20.98L12.8377 21.1174H11.1883L11.0509 20.98Z",
    fill: "#05BDBA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_61"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21.1875,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetlifyicon);
export default __webpack_public_path__ + "static/media/netlifyicon.192911e0d80ccdba01b7f717aeaf1347.svg";
export { ForwardRef as ReactComponent };